module.exports = __webpack_public_path__ + "9a661f52aa638815eb19ea4571856d06.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/JE.svg
// module id = VTnN
// module chunks = 0